// Dev task workflow columns, in board order.
export const DEV_STATUSES = [
  { value: 'todo', label: 'To Do' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'revision', label: 'Task for Revision' },
  { value: 'testing', label: 'Testing' },
  { value: 'ready_for_release', label: 'Ready for Release' },
  { value: 'done', label: 'Done' },
];

export const DEV_STATUS_LABELS = Object.fromEntries(DEV_STATUSES.map(s => [s.value, s.label]));

// Columns collapsed by default on the board.
export const DEFAULT_COLLAPSED_STATUSES = ['done'];
